/**
 * The EHR Tasks report's task types: the options of its Task Types filter, stored as
 * ehr_task_filter (utils/reportFilterTerms.js), and who may see the report at all.
 *
 * task_type is the bucket key the report Lambdas return and filter on (EHR_TASK_BUCKETS in
 * mysql_report.py and report_generator.py). The buckets are the EHR Tasks page's tabs
 * (docs/EHR_TASKS_REPORT_PLAN.md section 3.2), so the order here is the page's tab order.
 * String keys, not numbers: they never collide with the staging status codes.
 */

import { getEhrInfo, getSession } from '../services/session.js';
import { iAmHigherAuthority } from '../libs.jsx';

export const EHR_TASK_TYPES = [
    { task_type: 'move_in', task_type_name: 'Move-ins', section: 'residents' },
    { task_type: 'relocate', task_type_name: 'Relocations', section: 'residents' },
    { task_type: 'move_out', task_type_name: 'Move-outs', section: 'residents' },
    { task_type: 'user_add', task_type_name: 'Add User', section: 'users' },
    { task_type: 'user_remove', task_type_name: 'Remove User', section: 'users' },
];

/**
 * The task types this campus's EHR integration sends: residents when the vendor is
 * receiving residents, users when it is receiving users. The same flags decide the
 * EHR Tasks page's Residents / Users tabs (TasksEhrPage showResidentsTab / showUsersTab).
 */
export function ehrTaskTypeOptions(campusId) {
    const info = getEhrInfo(campusId);
    return EHR_TASK_TYPES.filter((t) => (t.section === 'residents' ? info.receiving_resident : info.receiving_user));
}

/**
 * The EHR Tasks report's gate, the same rule as the EHR Tasks nav link and the /tasks/ehr
 * dispatcher (components/Tasks.jsx): an active EHR integration on the campus and a role
 * weight above 10.
 */
export function canSeeEhrTasksReport(campusId) {
    return getEhrInfo(campusId).active && iAmHigherAuthority(10, getSession()?.role_weight);
}
